export const paths = {
  home: '',
  photovoltaics: 'fotovoltaicka-elektrarna',
  ems: 'ems',
  boiler: 'bojler',
  grid: 'distribucni-sit',
  heatPump: 'tepelne-cerpadlo',
  statistics: 'statistiky',
  settings: 'nastaveni',
  spot: 'spot',
  plug: 'plug',
  relay: 'relay',
  energyMeters: 'elektromery',
  product_test: 'product-test',
  thermostat: 'thermostat',
  protocol: 'protokol',
  wallbox: 'wallbox',
  wallboxList: 'wallbox/seznam',
  rfidCards: 'rfid-cards',
  wind: 'vetrna-elektrarna',
  devHomepage: 'dev',
  network: 'dev/network',
  deltaGreen: 'dev/delta-green',
  electree: 'dev/electree',
  energomachine: 'dev/energomachine',
  mqttCloud: 'dev/mqtt-cloud',
  mqttBroker: 'dev/mqtt-broker',
  shellies: 'dev/shellies',
  azRouters: 'dev/az-routers',
  scripts: 'dev/scripts',
  bezDodavatele: 'dev/bez-dodavatele',
  preFlexibility: 'dev/pre-flexibility',
  enerco: 'dev/enerco',
  devCloudPlugs: 'dev/zasuvky-cloud',
  devSubscriptions: 'dev/predplatne',
  expertService: 'expert-service',
  expertServiceNetwork: 'expert-service/network',
  emsService: 'ems-service',
  appMessages: 'zpravy',
  cloudPlugs: 'zasuvky-cloud',
  auditLog: 'audit-log',
  devAppMessages: 'dev/zpravy',
  devStatusLog: 'dev/status-log',
  devInverterConfig: 'dev/konfigurace-stridacu',
  customPage: 'custom/:tabUrl',
  reports: 'reporty',
  reportDetail: 'reporty/:month',
};

export const links = {
  home: '/',
  photovoltaics: '/fotovoltaicka-elektrarna',
  ems: '/ems',
  boiler: '/bojler',
  grid: '/distribucni-sit',
  heatPump: '/tepelne-cerpadlo',
  statistics: '/statistiky',
  settings: '/nastaveni',
  spot: '/spot',
  plug: '/plug',
  relay: '/relay',
  energyMeters: '/elektromery',
  product_test: '/product-test',
  thermostat: '/thermostat',
  protocol: '/protokol',
  wallbox: '/wallbox',
  wallboxList: '/wallbox/seznam',
  rfidCards: '/rfid-cards',
  wind: '/vetrna-elektrarna',
  appMessages: '/zpravy',
  cloudPlugs: '/zasuvky-cloud',
  devHomepage: '/dev',
  expertService: '/expert-service',
  exportServiceNetwork: '/expert-service/network',
  emsService: '/ems-service',
  auditLog: '/audit-log',
  devStatusLog: '/dev/status-log',
  devInverterConfig: '/dev/konfigurace-stridacu',
  customPage: '/custom/:tabUrl',
  reports: '/reporty',
  reportDetail: '/reporty/:month',
};
